import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse, createParamString } from 'data_sources/constants';
import { PerformanceReportingTop5SummariesResponse } from '../_types';
import { generateTop5Summaries } from './performanceReportingDataGenerator';
import { useRiskPoolPerformanceReportingDemo } from '../../../../_data_sources/useRiskPoolPerformanceReportingDemo';

interface UseTop5SummariesParams {
  orgId: string;
  childOrgId: string;
  assignedModule: string;
  startDate: string;
  endDate: string;
}

export default function useTop5Summaries(
  params: UseTop5SummariesParams,
  options: object = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const useDemoData = useRiskPoolPerformanceReportingDemo();

  return useQuery<PerformanceReportingTop5SummariesResponse, Error>(
    [
      'risk_pool_perf_report_top_5_summaries',
      params.orgId,
      params.childOrgId,
      params.assignedModule,
      params.startDate,
      params.endDate,
    ],
    async (): Promise<PerformanceReportingTop5SummariesResponse> => {
      try {
        if (useDemoData) {
          const demoData = generateTop5Summaries(params.childOrgId, params.assignedModule, params.startDate, params.endDate);
          console.log('[useTop5Summaries] Demo Data Response:', JSON.stringify(demoData, null, 2));
          return demoData;
        }

        const queryParams = createParamString({
          assignedModule: params.assignedModule,
          startDate: params.startDate,
          endDate: params.endDate,
        });
        const url = `${baseApiUrl()}/organizations/${params.orgId}/risk-pool/related-organizations/${params.childOrgId}/performance-reporting/top-5-summaries?${queryParams}`;
        const data: PerformanceReportingTop5SummariesResponse = await fetcher({
          method: 'get',
          url,
        });
        console.log('[useTop5Summaries] API Response:', JSON.stringify(data, null, 2));
        return data;
      } catch (err) {
        if (onError) onError(err as ServerErrorResponse);
        throw err;
      }
    },
    {
      ...options,
      enabled:
        !!params.orgId &&
        !!params.childOrgId &&
        !!params.assignedModule &&
        !!params.startDate &&
        !!params.endDate,
    }
  );
}

